import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessAgentContextRoute: InvariantJiraRoute = {
	name: 'business-agent-context',
	exact: true,
	path: '/jira/core/projects/:projectKey/agent-context',
};
